import React from 'react';
import { ReactComponent as FigTag02Component } from './FigTag02.svg';

const FigTag02 = (props) => <FigTag02Component {...props} />;

export default FigTag02;
